<template>
	<div class="no-data">
		<img src="../assets/noMessage.png" alt="">
		<p>暂无数据</p>
	</div>
</template>

<script>
	export default {
		name: "NoData",
	}
</script>

<style scoped>
	.no-data{
		text-align: center;
	}
</style>
